/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { FilterClinicPathwayDto } from '../../models/filter-clinic-pathway-dto';
import { ResponseClinicPathwayDto } from '../../models/response-clinic-pathway-dto';

export interface ClinicPathwaysControllerFilter$Params {
      body: FilterClinicPathwayDto
}

export function clinicPathwaysControllerFilter(http: HttpClient, rootUrl: string, params: ClinicPathwaysControllerFilter$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<ResponseClinicPathwayDto>>> {
  const rb = new RequestBuilder(rootUrl, clinicPathwaysControllerFilter.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<ResponseClinicPathwayDto>>;
    })
  );
}

clinicPathwaysControllerFilter.PATH = '/thalea-pathways/clinic-pathways/filter';
